<template>
  <div>
    <item-detail :data="item" :is-mobile="isMobile" :user="user" class="form-check form-check-inline" v-for="(item, index) in items" v-bind:key="index">
    </item-detail>
  </div>
</template>

<script>
import ItemDetail from '@/components/Job/ItemDetail'

export default {
  props: {
    items: {
      type: Array | Object,
      default: [],
      required: false,
    },
    isMobile : {
      type: Boolean,
      default: false,
      required: false,
    },
    user: {
      type: Array | Object | null,
      default: false,
      required: false,
    }
  },
  components: {
    ItemDetail
  },
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
  },
  computed: {
  }
}
</script>
